import { bootstrapApplication } from '@angular/platform-browser';
import posthog from 'posthog-js';
import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';

posthog.init('phc_zPX1iiKN5ErvhSC45nhfd09HdH9iM3U6PtUgqwz89Ul', {
  api_host: 'https://pineapple.summerry.com',
  ui_host: 'https://eu.i.posthog.com',
  person_profiles: 'always',
});

bootstrapApplication(AppComponent, appConfig).catch(err => console.error(err));
